module.exports = __webpack_public_path__ + "img/地理标志图标.4a8354d7.svg";